export const VALIDATE_MENU_PATH_URL = 'users/validateMenuRights';

export const exclusionPatterns = [
  '/404',
  '/activity-logs',
  '/employee/reports/',
  '/employee/allowance/add',
  '/employee/allowance/edit',
  '/employee/allowance/view',
  '/approvals/hr/hr-approval-list',
  '/approvals/assets/asset-approval-list',
  '/approvals/finance/finance-approval-list',
  '/approvals/operation/operation-approval-list',
  '/approvals/operation/operation-approval-list/operationapprovaldetails',
  '/approvals/assets/asset-approval-list/assetapprovaldetails',
  '/approval/financeapprovaldetails',
  '/approvals/hr/hr-approval-list/details',
  '/employee/employee-detail',
  '/employee/newEmployee',
  '/employee/editEmployee',
  '/missing-punch',
  '/job-opening',
  '/job-opening/details',
  '/approvals/finance/finance-approval-list/supplierPaymentDtl',
  '/approvals/finance/finance-approval-list/prepaidVoucherDtl',
  '/approvals/operation/operation-approval-list/customerReqRegDtl',
  '/approvals/operation/operation-approval-list/supplierAgreementDtl',
  '/approvals/operation/operation-approval-list/TemporaryCreditCardRequisitionDtl',
  '/approvals/operation/operation-approval-list/PurchaseRequisitionDtl',
  '/approvals/operation/operation-approval-list/StockAdjustmentRequsitionDtl',
  '/approvals/operation/operation-approval-list/WhouseForeignPDSdtl',
  '/approvals/operation/operation-approval-list/DestroyVoucherDtl',
  '/approvals/finance/finance-approval-list/ServiceInvoiceDtl',
  '/approvals/operation/operation-approval-list/PriceChangeRequisitionFreshDtl',
  '/approvals/operation/operation-approval-list/SupplierRegReqDtl',
  '/approvals/hr/hr-approval-list/EmployeeLoanAppicationDtl',
  '/approvals/hr/hr-approval-list/EmployeePunchNoteDtl',
  '/approvals/hr/hr-approval-list/EmployeeLeaveExtensionDtl',
  '/config/control-config',
  '/config/ui-config',
  '/config/ui-config/marginSalesTable',
  '/file-upload/files',
  '/vendors/vendor-detail',
  '/vendors/pendingVendorDetail',
  '/vendors/editVendor',
  '/changePassword',
  '/vendors/editPendingVendorDetail',
  '/changePin',
  '/approvals/hr/hr-approval-list/EmployeeTransferDtl',
  '/employee/wps/',
  '/vendors/addNewBDA',
  '/LicenseKeyDetails',

  '/payslip/entry/',
  '/payslip/entry/newEntry',
  '/SalesOrder/AddSalesOrder',
  '/SalesOrder/EditSalesOrder',
  '/SalesOrder/print',
  '/sales-order/print',
  '/purchase-order/add',
  '/purchase-order/edit',
  '/purchase-order/print',
  '/purchase-order/view',
  '/goods-receipt/view',
  '/cheque-print/print',
  '/product-master/view',
  '/customer-master/new',
  '/customer-master/view',
  '/vendor-master/new',
  '/vendor-master/view',
  '/new-listing/details',
  '/sales-plan/AddSalesPlan',
  '/sales-plan/SalesPlanDetails',
  '/sales-plan/EditSalesPlan',
  '/target-sales/Zone-target',
  '/hr/payroll-period',
  '/payroll-period',
  '/customer/excel-upload',
  '/customer-item-upload',
  // division heads have no menu right; the server checks who may see each review
  '/access-reviews',
  // document pages under a menu page: the API checks the page rights on every call
  '/procurement/requisitions/',
  '/procurement/goods-receipts/',
  '/procurement/purchase-returns/',
  '/sales/invoices/',
  '/sales/returns/',
  '/sales/price-change-requests/',
  '/sales/quotations/',
  '/config/transaction-setup/',
  '/finance/journal-entries/',
  '/finance/customer-receipts/',
  '/finance/customer-statements/',
  '/sales/pick-lists/',
  '/inventory/stock-transfers/',
  '/inventory/stock-adjustments/',
  '/inventory/stock-count/',
  '/warehouse/bins/',
  '/procurement/rfq/',
  '/procurement/import-shipments/',
];
